import React, { useState } from "react";
import TransferFunds from "./TransferFunds/TransferFunds";
import Help from "./Help/Help";
import styled from "styled-components";

const ManageScreenWrapper = styled.div`
  display: flex;
  gap: 50px;
  width: 100%;
  margin-top: 80px;
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
  }

  .transferFundsSection {
    width: 50%;
    border-right: 2px solid lightgray;
    padding-right: 20px;
    @media (max-width: 480px) {
      width: 100%;
      padding: 0 0 50px 0;
      border-right: none;
      border-bottom: 2px solid lightgray;
    }
  }

  .helpSection {
    width: 50%;
    @media (max-width: 480px) {
      width: 100%;
    }
  }
`;

const ManageScreen = ({ transferGoals, setActiveTab, goalIdToManage }) => {
  const [selectedGoal, setSelectedGoal] = useState("");

  const handleSelectedGoalChange = (goalId) => {
    setSelectedGoal(goalId);
  };
  return (
    <ManageScreenWrapper>
      <div className="transferFundsSection">
        <TransferFunds
          transferGoals={transferGoals}
          selectedGoal={selectedGoal}
          selectedGoalOnChange={handleSelectedGoalChange}
          setActiveTab={setActiveTab}
          goalIdToManage={goalIdToManage}
        />
      </div>
      <div className="helpSection">
        <Help selectedGoal={selectedGoal} />
      </div>
    </ManageScreenWrapper>
  );
};

export default ManageScreen;
